// src/components/common/Logo.js
export default function Logo({ className = '', ...props }) {
    return (
        <svg
            width="100"
            height="120"
            viewBox="0 0 100 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className} // 应用外部传入的 className
            {...props} // 传递其他所有 props
        >
            <defs>
                <linearGradient id="shieldGradient" x1="0" y1="0" x2="100" y2="120" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#4A90E2"/>
                    <stop offset="1" stopColor="#357ABD"/>
                </linearGradient>
            </defs>
            <path d="M50 0L0 30V90L50 120L100 90V30L50 0Z" fill="url(#shieldGradient)"/>
            <circle cx="50" cy="60" r="10" stroke="white" strokeWidth="2"/>
            <circle cx="50" cy="60" r="17.5" stroke="white" strokeWidth="2" strokeOpacity="0.8"/>
            <circle cx="50" cy="60" r="25" stroke="white" strokeWidth="2" strokeOpacity="0.8"/>
        </svg>
    );
}
